import { render } from "./jdcxstyfp.vue?vue&type=template&id=2c2aaa40&scoped=true"
import script from "./jdcxstyfp.vue?vue&type=script&lang=js"
export * from "./jdcxstyfp.vue?vue&type=script&lang=js"

import "./jdcxstyfp.vue?vue&type=style&index=0&id=2c2aaa40&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c2aaa40"]])

export default __exports__